import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost, apiPatch, apiDelete } from '../api/client.js';

export const useClients = () =>
  useQuery({ queryKey: ['clients'], queryFn: () => apiGet('/clients') });

export const useClient = (id) =>
  useQuery({ queryKey: ['clients', id], queryFn: () => apiGet(`/clients/${id}`), enabled: !!id });

export const useCreateClient = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiPost('/clients', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['clients'] }),
  });
};

export const useUpdateClient = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiPatch(`/clients/${clientId}`, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['clients'] });
      qc.invalidateQueries({ queryKey: ['clients', clientId] });
    },
  });
};

export const useSetCredential = (clientId) => {
  return useMutation({
    mutationFn: (data) => apiPost(`/clients/${clientId}/credentials`, data),
  });
};

export const useDeactivateCredential = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiDelete(`/clients/${clientId}/credentials`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['clients'] });
      qc.invalidateQueries({ queryKey: ['clients', clientId] });
    },
  });
};

export const useGenerateApiKey = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiPost(`/clients/${clientId}/api-keys`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['apikeys', clientId] }),
  });
};
